import { useEffect, useState } from 'react'
import { makeGetRequest } from 'utils/api'
import { useImmer } from 'use-immer'
import Select from 'react-select'
import { toCurrencies } from './serializers'
import s from './Currency.scss'
import { Button } from 'reactstrap'
import { refreshToken } from 'utils/authService'
import { DATE_FORMAT } from 'utils/constants'

const Currency = ({ details, saveDetails }) => {
  const [organizationDetails, setOrganizationDetails] = useImmer(details)
  const [currencies, setCurrencies] = useState([])

  useEffect(() => {
    ;(async () => {
      const response = await makeGetRequest('/v1/dictionaries/currencies')
      setCurrencies(toCurrencies(response))
    })()
  }, [])

  useEffect(() => {
    setOrganizationDetails(() => {
      return details
    })
  }, [details, setOrganizationDetails])

  return (
    <>
      <h5>Currency</h5>
      <p>
        Select your preferred currency. This preference will be automatically applied to all user
        accounts
      </p>
      <Select
        onChange={value => {
          setOrganizationDetails(state => {
            state.currency = value
          })
        }}
        options={currencies}
        className={s.currencySelect}
        value={organizationDetails.currency}
        id="currency_select_cy"
      />

      <h5>Date Format</h5>
      <p>Select your preferred date format.</p>
      <Select
        onChange={value => {
          setOrganizationDetails(state => {
            state.dateFormat = value
          })
        }}
        options={Object.keys(DATE_FORMAT).map(value => ({
          value,
          label: DATE_FORMAT[value]
        }))}
        className={s.currencySelect}
        value={organizationDetails.dateFormat}
        id="date_select_cy"
      />

      <Button
        className={s.saveBtn}
        onClick={() => saveDetails(organizationDetails, refreshToken)}
        data-cy="submit_btn"
      >
        Save
      </Button>
    </>
  )
}

export default Currency
